import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/router/index";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/core/auth/AuthContext";
import { ToastProvider } from "@/components/ui/Toast";
import { ImpersonationProvider } from "@/core/auth/ImpersonationContext";
import { ScriptInjector } from "@/core/settings/ScriptInjector";
import { ImpersonationBanner } from "@/shared/layout/ImpersonationBanner";
import { Toaster } from "sonner";
import { AIProvider } from "@/core/ai/AIContext";
import { GlobalAIChatDrawer } from "@/core/ai/GlobalAIChatDrawer";
import { AIFloatingButton } from "@/core/ai/AIFloatingButton";

// Landscape v5.0 – Phase 22: Service Layer Refactor + RoleGuard
function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AIProvider>
            <ToastProvider>
              <Toaster position="top-right" richColors />
              <ImpersonationProvider>
                <ScriptInjector />
                <ImpersonationBanner />
                <AppRoutes />
                <GlobalAIChatDrawer />
                <AIFloatingButton />
              </ImpersonationProvider>
            </ToastProvider>
          </AIProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
